import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';

import iconArrow from '../assets/img/common/icon_arrow.svg';

import '../assets/scss/components/menu.scss';

import { updateMenuOpen } from '../store/globalReducer';

export default function Menu() {
  const dispatch = useDispatch();
  const location = useLocation();

  const menuBodyEl = useRef(null);

  const indexPinList = useSelector(state => state.temples.templeData.filter(el => {
    return el.show_on_map === 'index' && el.name_jp
  }));
  const areaPinList = useSelector(state => state.temples.templeData.filter(el => {
    return el.show_on_map === 'katsurahama' && el.name_jp
  }));
  const areaTwoPinList = useSelector(state => state.temples.templeData.filter(el => {
    return el.show_on_map === 'sakawa' && el.name_jp
  }));
  const isMenuOpen = useSelector(state => state.global.isMenuOpen);
  const isDetailPage = useSelector(state => state.global.isDetailPage);
  const [activeList, setActiveList] = useState('index');

  const menuState = {
    open: { x: '0', transition: { ease: 'easeOut', duration: 0.4, delay: 0.3 } },
    closed: { x: '100%', transition: { ease: 'easeOut', duration: 0.4 } }
  }

  const listState = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 }
  }

  useEffect(() => {
    dispatch(updateMenuOpen(false));
    setTimeout(() => {
      menuBodyEl.current.scrollTop = 0
    }, 500);
  }, [location]);

  const handleCloseClick = e => {
    e.preventDefault();
    dispatch(updateMenuOpen(false));
    setTimeout(() => {
      menuBodyEl.current.scrollTop = 0
    }, 500);
  }

  const handleOptionClick = (e, label) => {
    e.preventDefault();
    setActiveList(label);
  }

  return (
    <>
      <motion.div
        className="menu"
        initial={{ x: '100%' }}
        animate={isMenuOpen ? menuState.open : menuState.closed}>
        <div className="menu__inner">
          <div className="menu__head">
            <div className="menu__options">
              <div className="menu__option">
                <a href="#"
                  className={`${activeList === 'index' ? 'is-checked' : ''}`}
                  onClick={e => handleOptionClick(e, 'index')}>
                  <div className="menu__option-check"></div>
                  <span>全体マップ</span>
                </a>
              </div>
              <div className="menu__option">
                <a href="#"
                  className={`${activeList === 'katsurahama' ? 'is-checked' : ''}`}
                  onClick={e => handleOptionClick(e, 'katsurahama')}>
                  <div className="menu__option-check"></div>
                  <span>桂浜</span>
                </a>
              </div>
              <div className="menu__option">
                <a href="#"
                  className={`${activeList === 'sakawa' ? 'is-checked' : ''}`}
                  onClick={e => handleOptionClick(e, 'sakawa')}>
                  <div className="menu__option-check"></div>
                  <span>佐川</span>
                </a>
              </div>
            </div>
            <div className="menu__close">
              <a href="#" onClick={handleCloseClick}><span></span><span></span></a>
            </div>
          </div>

          <div className="menu__body" ref={menuBodyEl}>
            <AnimatePresence>
              {activeList === 'index' && (
                <motion.div
                  className="menu__block"
                  initial={listState.hidden}
                  animate={listState.visible}
                  exit={listState.hidden}>
                  <div className="menu__list">
                    {indexPinList.map((item, index) => (
                    <div className="menu__item" key={index}>
                      <Link to={`${item.name_en}`}>
                        <span>{item.name_jp}</span>
                        <i><img src={iconArrow} alt="" /></i>
                      </Link>
                    </div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            <AnimatePresence>
              {activeList === 'katsurahama' && (
                <motion.div
                  className="menu__block"
                  initial={listState.hidden}
                  animate={listState.visible}
                  exit={listState.hidden}>
                  <div className="menu__list">
                    {areaPinList.map((item, index) => (
                      <div className="menu__item" key={index}>
                        <Link to={`${item.name_en}`}>
                          <span>{item.name_jp}</span>
                          <i><img src={iconArrow} alt="" /></i>
                        </Link>
                      </div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>

            <AnimatePresence>
              {activeList === 'sakawa' && (
                <motion.div
                  className="menu__block"
                  initial={listState.hidden}
                  animate={listState.visible}
                  exit={listState.hidden}>
                  <div className="menu__list">
                    {areaTwoPinList.map((item, index) => (
                      <div className="menu__item" key={index}>
                        <Link to={`${item.name_en}`}>
                          <span>{item.name_jp}</span>
                          <i><img src={iconArrow} alt="" /></i>
                        </Link>
                      </div>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </motion.div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            className="menu-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 0.4, delay: 0.3 } }}
            exit={{ opacity: 0, transition: { duration: 0.4 } }}
            onClick={handleCloseClick}>
          </motion.div>
        )}
      </AnimatePresence>

    </>
  )
}